import { configureStore } from "@reduxjs/toolkit";
import classSubjectReducer from "../slices/classSubjectSlice";

export const store = configureStore({
  reducer: {
    classSubject: classSubjectReducer,
  },
});

